export default __webpack_public_path__ + "static/ebriefready-website-1400-9926ecaa423d8120a9ed689d245c6e72.jpg";